import { styled } from '@mui/system';
import { Divider } from '@mui/material';

export const RowDivider = styled(Divider)(({ theme }) => ({
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
}));
